/**
 * Route names defined for routes that only ticketSeller user type can access
 */
export const ticketSellerRouteNames = {
  dashboard: 'ticket-seller-dashboard',
  tickets: 'ticket-seller-tickets',
  purchase: 'ticket-seller-purchase-page',
  orders: 'ticket-seller-orders',
  orderDetails: 'ticket-seller-order-details',
  reports: 'ticket-seller-reports',
  report: 'ticket-seller-report',
  reportPdf: 'ticket-seller-report-pdf',
  cashRegisterStatePdf: 'cash-register-state-pdf',
}
